import { render } from "./RadioGroupInlineColor.vue?vue&type=template&id=32ce241c"
import script from "./RadioGroupInlineColor.vue?vue&type=script&lang=js"
export * from "./RadioGroupInlineColor.vue?vue&type=script&lang=js"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__